export default __webpack_public_path__ + "static/radar-8a953325f54d556c0cd7033423394f60.png";